/* Brain supplements page: the hero's help chips (sections/nr-collection-hero.liquid).
   Picking a chip presses it and marks the product card for the same product
   (sections/nr-collection-products.liquid) as the best match; picking it
   again clears the mark. On phones, where the cards swipe, the matching
   card is scrolled into the row. */

if (!customElements.get('nr-goal-chips')) {
  customElements.define(
    'nr-goal-chips',
    class NrGoalChips extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const chip = event.target.closest('.nr-coll-chip');
          if (chip) this.pick(chip);
        });
      }

      pick(chip) {
        const on = chip.getAttribute('aria-pressed') !== 'true';
        this.querySelectorAll('.nr-coll-chip').forEach((other) => {
          other.setAttribute('aria-pressed', String(other === chip && on));
        });

        const id = on ? chip.dataset.productId : '';
        let match = null;
        document.querySelectorAll('.nr-coll-card').forEach((card) => {
          const isMatch = id !== '' && card.dataset.productId === id;
          card.classList.toggle('is-match', isMatch);
          if (isMatch && !match) match = card;
        });

        const row = match && match.parentElement;
        if (row && row.scrollWidth > row.clientWidth) {
          row.scrollTo({ left: match.offsetLeft - row.offsetLeft, behavior: 'smooth' });
        }
      }
    }
  );
}
